import { accordionItemBuilder, Box, Text } from '@wix/design-system';
import { ChevronRightSmall } from '@wix/wix-ui-icons-common/on-stage';
import React, { useCallback } from 'react';
import { useOnToggleFunctions } from '../../utils/use-on-toggle-functions';
import { GroupSuffix } from './group-suffix';
export const useButtonGroup = _ref => {
  let {
    ruleGroups,
    selectedItemHeaderRef
  } = _ref;
  const {
    selectedGroup,
    onGroupToggle
  } = useOnToggleFunctions();
  return useCallback(ruleGroupOrigin => {
    const {
      groupId,
      ruleGroupContent,
      disabled = false
    } = ruleGroupOrigin;
    const {
      groupLabel,
      subtitles: groupSubtitles
    } = ruleGroupContent;
    return accordionItemBuilder({
      buttonType: 'node',
      collapseLabel: /*#__PURE__*/React.createElement(ChevronRightSmall, null),
      disabled,
      expandLabel: /*#__PURE__*/React.createElement(Box, {
        marginTop: "SP1"
      }, /*#__PURE__*/React.createElement(ChevronRightSmall, null)),
      key: groupId,
      onToggle: () => onGroupToggle(ruleGroups, groupId),
      open: false,
      showLabel: 'always',
      subtitle: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "thin",
        secondary: true
      }, groupSubtitles),
      suffix: /*#__PURE__*/React.createElement(GroupSuffix, {
        datahook: groupId,
        isOpen: false,
        ruleGroupContent: ruleGroupContent
      }),
      title: /*#__PURE__*/React.createElement("div", {
        "data-hook": groupLabel,
        ref: (selectedGroup == null ? void 0 : selectedGroup.groupId) === groupId ? selectedItemHeaderRef : null,
        style: {
          wordBreak: 'break-word'
        }
      }, /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "bold"
      }, groupLabel))
    });
  }, [onGroupToggle, selectedGroup == null ? void 0 : selectedGroup.groupId, selectedItemHeaderRef, ruleGroups]);
};
//# sourceMappingURL=use-get-button-group.js.map